import { Box, Link } from "@mui/material";
import { BannerSettings } from "../../types/Settings";
import * as styles from "./imageBannerStyles";

interface ImageBannerProps {
    banner: BannerSettings;
}

const ImageBanner: React.FC<ImageBannerProps> = ({ banner }) => {
    if (!banner.imageUrl) {
        return null;
    }

    const image = (
        <Box
            component="img"
            sx={styles.imageBanner}
            alt={banner.alt}
            src={banner.imageUrl}
        />
    );

    return banner.url ? <Link href={banner.url}>{image}</Link> : image;
};

export default ImageBanner;
